import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useNavigate } from "react-router";

import { EPath } from "constants/path";
import { PrescriptionCard } from "./PrescriptionCard";

export interface IPrescriptionPatientCardProps {
  name?: string;
  email?: string;
  phone?: string;
  patientId?: string;
}

export const PrescriptionPatientCard = ({
  name,
  email,
  phone,
  patientId,
}: IPrescriptionPatientCardProps) => {
  const navigate = useNavigate();
  const persistedStyle = useMemo(
    () => ({
      className: "break-words",
      sx: { fontWeight: 600 },
    }),
    [],
  );
  const patientInformation = useMemo(
    () => [
      {
        label: "Name",
        value: <Typography {...persistedStyle}>{name ?? "N/A"}</Typography>,
      },
      {
        label: "Email",
        value: <Typography {...persistedStyle}>{email ?? "N/A"}</Typography>,
      },
      {
        label: "Phone",
        value: <Typography {...persistedStyle}>{phone ?? "N/A"}</Typography>,
      },
    ],
    [email, name, persistedStyle, phone],
  );

  const handleViewPatient = () => {
    if (patientId) {
      navigate(EPath.PATIENT_DETAIL.replace(":patientId", patientId));
    }
  };

  return (
    <PrescriptionCard
      title="Patient Information"
      items={patientInformation}
      onViewAction={handleViewPatient}
      actionButtonText="View Patient"
    />
  );
};
